require('es6-promise');
require('isomorphic-fetch');
import fetchHelper from '../helper/fetch-helper';

const config = require('../config');
const getUrlParam = require('./common-helper').getUrlParam;
const wxClient = require('wechat-jssdk/client');

let wxAuthInfo = null;
const fetchWXAuthInfo = (args) => {
  if (wxAuthInfo) {
    return new Promise((resolve, reject) => {
      resolve(wxAuthInfo);
    });
  }

  const url = encodeURIComponent(location.href.split('#').shift());
  const shopId = getUrlParam('shopId');
  return fetchHelper.get(`${config.getWXAuthInfoAPI}`, { shopId, reqUrl: url })
    .then(result => {
      if (result) { // 成功获取数据
        // wxAuthInfo = result.data; 此处不做缓存 每次调用都需要请求jsticket接口 否则操作不成功
        return result;
      }
    })
    .catch(err => {
      wxAuthInfo = null;
      if (args.error) {
        args.error({ errMsg: err.msg });
      }
      throw new Error(err.msg);
    });
};

const callWxClientMethod = (apiName, args) => {
  fetchWXAuthInfo(args)
    .then(authInfo => {
      if (!authInfo || !authInfo.appid) { // 如果没有数据 截止到这里
        return;
      }
      const _wxClient = wxClient(Object.assign({
        debug: false,
        appId: authInfo.appid,
        timestamp: 0,
        nonceStr: authInfo.noncestr,
        signature: '',
        success: suc => {
          const wx = _wxClient.wx || window.wx;
          if (wx && wx[apiName]) {
            wx[apiName](args);
          }
        },
        error: err => {
          if (args.error) {
            args.error(err);
          }
        },
        jsApiList: [
          apiName,
        ],
      }, authInfo));
    })
    .catch(err => { // 兼容处理
      if (args.error) {
        args.error(err);
      }
    });
};

const registerWxClientEvent = (events, args) => {
  fetchWXAuthInfo(args)
    .then(authInfo => {
      if (!authInfo || !authInfo.appid) { // 如果没有数据 截止到这里
        return;
      }
      const _wxClient = wxClient(Object.assign({
        debug: false,
        appId: authInfo.appid,
        timestamp: 0,
        nonceStr: authInfo.noncestr,
        signature: '',
        success: suc => {
          const wx = _wxClient.wx || window.wx;
          args.success(wx);
        },
        error: err => {
          if (args.error) {
            args.error(err);
          }
        },
        jsApiList: events,
      }, authInfo));
    });
};

// 领取微信卡券 专用
let weixinCard = null;
const fetchWeixinCard = (args) => {
  if (weixinCard) {
    return new Promise((resolve, reject) => {
      resolve(weixinCard);
    });
  }
  const url = encodeURIComponent(location.href.split('?').shift());
  return fetch(`${config.getWXCardAPI}?shopId=${args.shopId}&cardId=${args.cardId}&reqUrl=${url}`, config.requestOptions)
    .then(res => {
      if (!res.ok) {
        throw new Error('获取信息失败...');
      }
      return res.json();
    })
    .then(result => result.data || {})
    .catch(err => {
      weixinCard = {};
      throw new Error(err);
    });
};

// 领取微信卡券 专用
const callWxCardClientMethod = (apiName, args) => {
  fetchWXAuthInfo(args)
    .then(authInfo => {
      fetchWeixinCard(args)
        .then(wxCard => {
          const strCardExt = '{"nonce_str":"' + wxCard.noncestr + '","timestamp":"' + wxCard.timestamp + '","signature":"'
            + wxCard.signature + '"}';
          const _wxClient = wxClient({
            debug: false,
            appId: authInfo.appid,
            timestamp: authInfo.timestamp,
            nonceStr: authInfo.noncestr,
            signature: authInfo.signature,
            jsApiList: [
              apiName,
            ],
            success: suc => {
              if (args.success) {
                args.success();
              }
              const wx = _wxClient.wx || window.wx;
              if (wx[apiName]) {
                wx[apiName]({
                  cardList: [{
                    cardId: wxCard.cardId,
                    cardExt: strCardExt,
                  }],
                  success: data => {
                    if (args.success) {
                      args.success(data);
                    }
                  },
                  error: data => {
                    if (args.error) {
                      args.error(data);
                    }
                  },
                });
              }
            },
            error: err => {
              if (args.error) {
                args.error(err);
              }
            },
          });
        })
        .catch(err => {
          args.error(err);
        });
    });
};

exports.callWxClientMethod = (name, args) => callWxClientMethod(name, args);
exports.registerWxClientEvent = (events, args) => registerWxClientEvent(events, args);
exports.callWxCardClientMethod = (name, args) => callWxCardClientMethod(name, args);



// WEBPACK FOOTER //
// ./src/helper/wx-client-helper.js